module.exports = __webpack_public_path__ + "static/media/footer.ed9236b4.png";